<div class='text-center mb3'>
  <h3>Enter your info below, and we'll<br/> keep you posted</h3>
</div>

<div class="card-layout no-border text-dark">
  <div class="row">
    <div class="col desktop--col-50 col-100">
      <label for="address-first-name">First Name*</label>
      <input id="address-first-name" value="{{ first_name }}" name="first_name" type="text" autocorrect="off" placeholder="Johnny" autofocus>
    </div>
    <div class="col desktop--col-50 col-100">
      <label for="address-last-name">Last Name*</label>
      <input id="address-last-name" value="{{ last_name }}" name="last_name" type="text" autocorrect="off" placeholder="Appleseed">
    </div>
  </div>
  <div class="row">
    <div class="col col-100">
      <label for="is-building-owner">I am a:*</label>
      <select class="default-disabled" id="is-building-owner"  name="is_building_owner">
        <option value="" disabled selected>Select one</option>
        <option value="false">Resident</option>
        <option value="true">Owner or Manager of this property</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-100 col-100">
      <label for="address-email">Email*</label>
      <input id="address-email" value="{{ email }}" name="email" type="email" autocorrect="off" placeholder="johnny@appleseed.com">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-100 col-100">
      <label for="address-street">Address*</label>
      <input id="address-street" value="{{ street }}" name="street" type="text" autocorrect="off" placeholder="123 Main Street">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-33 col-100">
      <label for="address-apt">Apt/Suite #</label>
      <input id="address-apt" value="{{ apt }}" name="apt" type="text" autocorrect="off" placeholder="10">
    </div>
    <div class="col desktop--col-66 col-100">
      <label for="address-city">City*</label>
      <input id="address-city" value="{{ city }}" name="city" type="text" autocorrect="off" placeholder="Boston">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-33 col-100">
      <label for="address-state">State*</label>
      <input id="address-state" value="{{ state }}" name="state" type="text" autocorrect="off" placeholder="MA" maxlength="2">
    </div>
    <div class="col desktop--col-33 col-100">
      <label for="address-zip">Zip*</label>
      <input id="address-zip" value="{{ postal_code }}" name="postal_code" type="text" autocorrect="off" placeholder="02110">
    </div>
    <div class="col desktop--col-33 col-100">
      <label for="address-phone">Phone Number</label>
      <input id="address-phone" value="{{ phone }}" name="phone" type="tel" autocorrect="off" placeholder="555-555-5555">
    </div>
  </div>
  <div class="row mt1">
    <div class="col col-100">
      <label class="custom_checkbox label disabled" for="sms_consent">
        <input disabled type="checkbox" id="sms_consent" name="sms_consent" {{ checked sms_consent true }}>
        <strong>Text me when Starry is available at my address</strong>. Texts may be automated. Carrier message and data rates may apply.
        <span class="checkbox_control"></span>
      </label>
    </div>
  </div>
  <div class="row">
    <input type="submit" class="hidden">
  </div>
</div>
